(function () {
  function initSection(section) {
    if (section.dataset.recentInit === 'true') return;
    var slider = section.querySelector('slider-component');
    if (!slider || typeof slider.init !== 'function') return;

    slider.init();
    section.dataset.recentInit = 'true';
    document.dispatchEvent(new CustomEvent('product-card-carousel:resync', { detail: { section: section } }));
  }

  function run() {
    if (!window.customElements || !customElements.get('slider-component')) return;
    if (document.readyState === 'loading') return;
    document.querySelectorAll('.ubiquiti-recently-released').forEach(initSection);
  }

  document.addEventListener('global.js loaded', run);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  run();
})();
